import { useQuery } from '@tanstack/react-query'
import { LobsterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useGetLabelInspectionResults = (ids: string[]) => {
  return useQuery({
    queryKey: queryKeys.labelInspectionResults(ids),
    queryFn: () =>
      baseClient
        .getApi(LobsterApi)
        .getReportLabelInspections({ ids })
        .catch(handleHTTPError),
    // 画面を二回目以降に開く際に、時間差でデータが更新されることによる事故を防ぐため
    gcTime: 0,
    enabled: ids.length > 0,
  })
}
